import EventDispatcher from "js-class.event-dispatcher";

import icon_controls from 'bundle-text:../assets/gamepad-solid.svg';
import icon_autoplay from 'bundle-text:../assets/play-solid.svg';
import icon_clickable from 'bundle-text:../assets/computer-mouse-scrollwheel-solid.svg';
import icon_muted from 'bundle-text:../assets/volume-slash-solid.svg';
import icon_cover from 'bundle-text:../assets/arrows-maximize-solid.svg';
import icon_ratio from 'bundle-text:../assets/crop-simple-solid.svg';
import icon_loop from 'bundle-text:../assets/repeat-solid.svg';
import icon_height from 'bundle-text:../assets/arrows-up-down-solid.svg';


export default class Setting {
	constructor(param) {
		this.events = new EventDispatcher(this);
		this.dom = null
		this.ui = {};
		this.loadParam(param)
		this.dom__init();
	}

	on(eventName, callback) { this.events.registerEvent(eventName, callback); }
	off(eventName, callback) { this.events.unregisterEvent(eventName, callback); }
	fire(eventName, data) { this.events.fireEvent(eventName, data); }

	getParam(k = null) {
		if (typeof k === 'string')
			return this.param[k];
		return { ...this.param };
	}
	setParam(k, v) {
		this.param[k] = v;
		this.dom__refresh();
		this.fire('change')
	}
	loadParam(param) {
		console.log(param)
		param = param || {};
		param.loop = typeof param.loop !== 'undefined' ? param.loop : true;
		param.controls = typeof param.controls !== 'undefined' ? param.controls : false;
		param.clickable = typeof param.clickable !== 'undefined' ? param.clickable : false;
		param.autoplay = typeof param.autoplay !== 'undefined' ? param.autoplay : true;
		param.muted = typeof param.muted !== 'undefined' ? param.muted : true;
		param.cover = typeof param.cover !== 'undefined' ? param.cover : true;

		if (typeof param.loop === "string") {
			let loop = (param.loop + ':').split(':');
			if (isNaN(loop[0])) loop[0] = 0;
			if (isNaN(loop[1])) loop[1] = 10;
		}
		console.log(param)

		this.param = param;
		this.dom__refresh();
	}
	toggleParam(k) {
		let v = this.getParam(k)
		this.setParam(k, v ? false : true);
	}

	dom__init() {
		this.dom = document.createElement('div')
		this.dom.innerHTML = `
			<div class="setting" part="autoplay">
				<span class="label">${icon_autoplay} Autoplay</span>
				<button></button>
			</div>
			<div class="setting" part="muted" title="Sound muted at startup">
				<span class="label">${icon_muted} Muted</span>
				<button></button>
			</div>
			<div class="setting" part="cover" title="Resize the video to allways fill the container">
				<span class="label">${icon_cover} Cover</span>
				<button></button>
			</div>
			<div class="setting" part="embed_ratio">
				<span class="label">${icon_ratio} video Ratio</span>
				<select>
					<option value="16:9">Generic 16:9</option>
					<option value="4:3">Generic 4:3</option>
					<option value="1:1">Generic 1:1</option>
					<option value="16:10">Wide 16:10</option>
					<option value="47:20">Ultra-Wide 21:9</option>
					<option value="3:4">Vertical 3:4</option>
					<option value="9:16">Vertical 9:16</option>
				</select>
			</div>
			<div class="setting" part="height">
				<span class="label">${icon_height} Height</span>
				<select>
					<option value="inherit">Inherit container size</option>
					<option value="ratio">Use video ratio</option>
				</select>
			</div>
			<div class="setting" part="controls">
				<span class="label">${icon_controls} Controls</span>
				<select>
					<option value="">None</option>
					<option value="bar">Bar</option>
					<option value="btn">Button</option>
				</select>
			</div>
			<div class="setting" part="clickable" title="Video play/pause on surface click">
				<span class="label">${icon_clickable} Clickable</span>
				<button></button>
			</div>
			<div class="setting" part="loop">
				<span class="label">${icon_loop} Loop</span>
				<select>
					<option value="">Off</option>
					<option value="auto">On</option>
					<option value="custom">Custom</option>
				</select>
			</div>
			<div class="setting" part="loop-custom">
				<span class="label">&nbsp;</span>
				<span class="input-group">
					<span part="loop-start" class="loop-input"><input type="number" value=""><span class="loop-suffix">s</span></span>
					<span part="loop-end" class="loop-input"><input type="number" value=""><span class="loop-suffix">s</span></span>
				</span>
			</div>
		`;
		this.ui.autoplay = this.dom.querySelector('[part="autoplay"] button');
		this.ui.autoplay.addEventListener('click', this.toggleParam.bind(this, 'autoplay'))

		this.ui.clickable = this.dom.querySelector('[part="clickable"] button');
		this.ui.clickable.addEventListener('click', this.toggleParam.bind(this, 'clickable'))

		this.ui.muted = this.dom.querySelector('[part="muted"] button');
		this.ui.muted.addEventListener('click', this.toggleParam.bind(this, 'muted'))

		this.ui.cover = this.dom.querySelector('[part="cover"] button');
		this.ui.cover.addEventListener('click', this.toggleParam.bind(this, 'cover'))

		this.ui.controls = this.dom.querySelector('[part="controls"] select');
		this.ui.controls.addEventListener('change', (event) => {
			let value = event.target.value;
			if (value === 'bar')
				this.setParam('controls', true)
			else if (value)
				this.setParam('controls', value)
			else
				this.setParam('controls', false)
		})

		this.ui.loop = this.dom.querySelector('[part="loop"] select');
		this.ui.loop_custom = this.dom.querySelector('[part="loop-custom"]');
		this.ui.loop_start = this.dom.querySelector('[part="loop-start"] input');
		this.ui.loop_end = this.dom.querySelector('[part="loop-end"] input');
		this.ui.loop.addEventListener('change', (event) => {
			let value = event.target.value;
			if (value === 'auto')
				this.setParam('loop', true)
			else if (value === 'custom')
				this.setParam('loop', '0:10')
			else
				this.setParam('loop', false)
		})

		this.ui.loop_start.addEventListener('keyup', (event) => this.updateCustomLoop('start'))
		this.ui.loop_start.addEventListener('blur', (event) => this.updateCustomLoop_delayed('start'))
		this.ui.loop_start.addEventListener('change', (event) => this.updateCustomLoop_delayed('start'))

		this.ui.loop_end.addEventListener('keyup', (event) => this.updateCustomLoop('end'))
		this.ui.loop_end.addEventListener('blur', (event) => this.updateCustomLoop('end'))
		this.ui.loop_end.addEventListener('change', (event) => this.updateCustomLoop_delayed('end'))

		this.ui.embed_ratio = this.dom.querySelector('[part="embed_ratio"] select');
		this.ui.embed_ratio.addEventListener('change', (event) => this.setParam('embed_ratio', event.target.value))

		this.ui.height = this.dom.querySelector('[part="height"] select');
		this.ui.height.addEventListener('change', (event) => this.setParam('height', event.target.value))

		this.dom__refresh();
	}

	updateCustomLoop(edit) {
		clearTimeout(this.updateCustomLoop_delay);
		this.updateCustomLoop_delay = setTimeout(this.updateCustomLoop_delayed.bind(this, edit), 1000);
	}
	updateCustomLoop_delayed(edit) {
		let a = parseInt(this.ui.loop_start.value) || 0;
		let b = parseInt(this.ui.loop_end.value) || 0;

		if (a >= b && edit == 'start')
			b = a + 1;
		if (a >= b && edit == 'end')
			a = b - 1;
		if (a + b == 0)
			b = 30;
		this.setParam('loop', a + ':' + b);
	}

	dom__btn_refresh(btn, status) {
		if (status) {
			btn.innerHTML = "On";
			btn.classList.add('on');
		}
		else {
			btn.innerHTML = "Off";
			btn.classList.remove('on');
		}
	}

	dom__refresh() {
		clearTimeout(this.dom__refresh_delay);
		this.dom__refresh_delay = setTimeout(this.dom__refresh_delayed.bind(this), 10);
	}

	dom__refresh_delayed() {

		if (!this.param.provider) {
			this.dom.style.display = 'none';
			return;
		}
		else {
			this.dom.style.display = null;;
		}

		this.dom__btn_refresh(this.ui.muted, this.param.muted);
		this.dom__btn_refresh(this.ui.autoplay, this.param.autoplay);
		this.dom__btn_refresh(this.ui.clickable, this.param.clickable);
		this.dom__btn_refresh(this.ui.cover, this.param.cover);

		if (this.param.provider === 'youtube' || this.param.provider === 'gumlet') this.ui.embed_ratio.style.display = '';
		else this.ui.embed_ratio.style.display = 'none';

		if (typeof this.param.loop === 'boolean' || typeof this.param.loop === 'undefined') this.ui.loop_custom.style.display = 'none';
		else this.ui.loop_custom.style.display = '';

		if (this.param.embed_ratio)
			this.ui.embed_ratio.value = this.param.embed_ratio;
		else
			this.ui.embed_ratio.value = '16:9';

		if (this.param.controls === true)
			this.ui.controls.value = 'bar';
		else if (this.param.controls === 'btn')
			this.ui.controls.value = 'btn';
		else
			this.ui.controls.value = '';

		this.ui.height.value = this.param.height || 'inherit';

		if (this.param.loop) {
			if (this.param.loop === true)
				this.ui.loop.value = 'auto';
			else if (this.param.loop.match(/:/))
				this.ui.loop.value = 'custom';
			else
				this.ui.loop.value = '';
		}
		else {
			this.ui.loop.value = '';
		}

		if (typeof this.param.loop === 'string') {
			let loop = (this.param.loop + ':').split(':');
			this.ui.loop_start.value = loop[0];
			this.ui.loop_end.value = loop[1];
		}
	}

}